import * as React from 'react';

const NotFoundPage = () => {
  return <h1 style={{ padding: '500px' }}>404 Not Found</h1>;
};

export default NotFoundPage;
